import Api from '../api';
const END_POINT = 'admin/users';

export default {
    state: {
        users: [],
    },

    getters: {
        users: state => state.users
    },

    mutations: {
        setUsers: (state, users) => state.users = users
    },

    actions: {
        async fetchUsers({commit}){
            const response = await Api.get(END_POINT);
            commit('setUsers', response.body.data);
        }
    }

}